module.exports = "<div class=\"load6\">\n  <div class=\"loader\">\n  </div>\n</div>\n"